export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://gapi.storyblok.com/v1/api", "httpLinkOptions": {"headers": {"Token": "zfCJjAHuQh8Q3mrTjY7VHwtt", "Version": "published"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}